import { createAction, props } from '@ngrx/store';
import { ProjectResourceChanges } from 'core/http/project/resource-updates/resource-updates.service';

export const getProjectResources = createAction('[Project Resources Request] Get Project Resources');
export const saveProjectResources = createAction('[Project Resources Store] Save Project Resources', props<{ resources: ProjectResourceChanges }>());
export const markProjectResourcesLoaded = createAction('[Project Resources Store] Mark Project Resources Loaded');
